import { Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router, Event, NavigationEnd } from '@angular/router';
import { AppConstants, LabelConstants } from 'src/app/utilities/app-constants';
import { environment } from 'src/environments/environment';
import { NavDataService } from 'src/app/modules/workshop/services/nav-data.service';
import { BatonFeature } from 'src/app/models/baton-features';
import { FolioEnums } from 'src/app/utilities/folio-enums';
import { FolioHelperService } from 'src/app/utilities/folio-helper.service';

@Component({
  selector: 'app-navigation-layout',
  templateUrl: './navigation-layout.component.html',
  styleUrls: ['./navigation-layout.component.css']
})
export class NavigationLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly MY_CONSTANT = LabelConstants;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private router: Router,
    private folioHelperServiceService: FolioHelperService,
    private navDataService: NavDataService) {

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.paddingValue = event.urlAfterRedirects !== '/assessments' ? '1rem' : '0rem';
      }
    });
  }

  username;
  mobileQuery: MediaQueryList;
  paddingValue = '1rem';
  private mobileQueryListener: () => void;
  alertsBadgeValue = '0';
  defaultRoute;
  // userAttributes;

  fillerNav = [
    // { name: 'Home', path: '/home', icon: 'home' },
    // { name: AppConstants.PARAM_MODULE_NAME_TEAMS, path: '/teams', icon: 'people' },
    // { name: AppConstants.PARAM_MODULE_NAME_PROJECTS, path: '/projects', icon: 'description' },
    // { name: AppConstants.PARAM_MODULE_NAME_ASSESSMENTS, path: '/assessments', icon: 'chat' },
    // { name: AppConstants.PARAM_MODULE_NAME_WORKSHOP, path: '/workshop', icon: 'group_work' },
    // { name: AppConstants.PARAM_MODULE_NAME_REPORTS, path: '/reports', icon: 'dashboard' },
  ];
  loginData = localStorage.getItem('CognitoIdentityServiceProvider.' +
    environment.paramAppsynUserPoolWebClientId + '.LastAuthUser');

  ngOnInit() {
    //  this.userAttributes = this.folioHelperServiceService.fetchDataFromLocalStorage('__login_info__');
    this.mobileQuery = this.media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this.mobileQueryListener);

    this.navDataService.load();
    this.navDataService.navData.subscribe(
      (suc: BatonFeature[]) => {
        this.fillerNav = [];

        if (!suc || !suc.length) {
          return;
        }

        // this.fillerNav.push({ name: 'Home', path: '/home', icon: 'home' });
        suc.forEach(navItem => {
          const obj = this.buildNavList(navItem);
          this.fillerNav.push(obj);
        });
        this.defaultRoute = localStorage.getItem(AppConstants.PARAM_LOCAL_STORAGE_DEFAULT_ROUTE);
      }, err => { }
    );

  }

  buildNavList(navItem: BatonFeature) {
    let obj = { name: navItem.FEATURE_NAME, path: '/workshop', icon: 'edit' };
    if (navItem.FEATURE_NAME === FolioEnums.features.team) {
      obj = { name: navItem.FEATURE_NAME, path: `/${AppConstants.PARAM_ROUTE_VALUE_TEAMS}`, icon: 'people' };
    } else if (navItem.FEATURE_NAME === FolioEnums.features.project) {
      obj = { name: navItem.FEATURE_NAME, path: `/${AppConstants.PARAM_ROUTE_VALUE_PROJECTS}`, icon: 'description' };
    } else if (navItem.FEATURE_NAME === FolioEnums.features.assessments) {
      obj = { name: navItem.FEATURE_NAME, path: `/${AppConstants.PARAM_ROUTE_VALUE_ASSESSMENTS}`, icon: 'assessment' };
    } else if (navItem.FEATURE_NAME === FolioEnums.features.workshops) {
      obj = { name: navItem.FEATURE_NAME, path: `/${AppConstants.PARAM_ROUTE_VALUE_WORKSHOPS}`, icon: 'group_work' };
    } else if (navItem.FEATURE_NAME === FolioEnums.features.reports) {
      obj = { name: navItem.FEATURE_NAME, path: `/${AppConstants.PARAM_ROUTE_VALUE_REPORTS}`, icon: 'dashboard' };
    } else if (navItem.FEATURE_NAME === FolioEnums.features.metrics) {
      obj = {
        name: navItem.FEATURE_NAME, path: `/${AppConstants.PARAM_ROUTE_VALUE_METRICS}`, icon: 'equalizer'
      };
    } else if (navItem.FEATURE_NAME === FolioEnums.features.stories) {
      obj = {
        name: navItem.FEATURE_NAME, path: `/${AppConstants.PARAM_ROUTE_VALUE_STORIES}`, icon: 'insert_comment'
      };
    }
    return obj;
  }

  loadDefaultPage() {
    this.router.navigate([`/${this.defaultRoute}`]);
    // this.router.navigate([`/workshop`]);

  }

  goToBatonConfig() {
    const loginInfo = this.folioHelperServiceService.fetchDataFromLocalStorage('__login_info__');
    window.location.href = environment.urlRedirectionBatonConfig + AppConstants.APP_ID + '&cognitoToken=' + loginInfo.sessionId;
  }

  buildUserName(): string {
    const name = this.loginData;
    // if (this.loginData != null) {
    //   name = this.loginData.firstname + ' ' + this.loginData.lastname;

    //   if (name === null) {
    //     name = this.loginData.username;
    //   } else if (name.length <= 0) {
    //     name = this.loginData.username;
    //   }
    // }
    return name;
  }

  logoutUser() {
    localStorage.clear();
    window.history.back();
    window.location.href = environment.urlRedirectToBaton
    // this.router.navigate(['/teams']);
    // localStorage.removeItem('token');
    // localStorage.removeItem('industryObject');
    // this.router.navigate(['/login']);
    // this.hideSideMenuIfLogin = true;
  }

  goToBatonDashboard() {
    window.location.href = environment.urlRedirectToBatonDashboard;
  }


  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
  }

  ngAfterViewInit(): void {
    /**
     * set this timeout to bypass the issue ===>
     * ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked.
     * Previous value: 'ngIf: false'. Current value: 'ngIf: true'.
     */
    setTimeout(() => {
      this.folioHelperServiceService.fetchedUserName.subscribe(name => {
        this.username = name;
      });
    }, 1000);
  }
}
